import { ReactNode } from 'react';
import { Table } from '@tanstack/react-table';
import { RequireExactlyOne } from 'type-fest';

import { Result, Status, Td, Tr } from '@oaknorth/component-core-v2';
import { T } from '@oaknorth/util-intl';

type TableEmptyStateProps<T extends object> = RequireExactlyOne<
  {
    table: Table<T>;

    /**
     * Optional prop to use when a table object is unavailable to set the number of columns for
     * the error state to show. Required if `table` is not provided.
     */
    numberOfColumns: number;
    emptyResult?: ReactNode;
  },
  'table' | 'numberOfColumns'
>;

export function TableEmptyState<T extends object = {}>({
  table,
  numberOfColumns,
  emptyResult,
}: TableEmptyStateProps<T>) {
  const amountVisibleColumns = table?.getVisibleLeafColumns().length || numberOfColumns;

  return (
    <Tr data-testid="table-empty">
      <Td colSpan={amountVisibleColumns}>{emptyResult ?? <Result status={Status.INFO} title={T`table.noData`} />}</Td>
    </Tr>
  );
}
